import { Icon } from "@atoms";
import { preloadCodeScanner } from "@pages/Pricebook/components/CodeScannerDialog/CodeScannerDialog";
import RegisterCodeDialog from "@pages/Pricebook/components/RegisterCodeDialog/RegisterCodeDialog";
import { faIcon } from "@utils/faIcon";
import React, { Component, Fragment } from 'react';
import UniversalButton from "../buttons/UniversalButton";


class BarcodeField extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isScannerOpen: false,
        };
    }

    render() {
        const {fieldName, fieldLabel, fieldValue, fieldOnChange, pricebookItemId, maxLength, placeholder, disabled=false, optional=false, optionalText="optional", errors, children} = this.props

        // Controlled, unlike the sibling fields, so a scanned code shows up in the input
        return (
            <div className="data-panel__form__field" id={`div_id_${fieldName}`} aria-label={fieldLabel}>
                <label htmlFor={`id_${fieldName}`} className="data-panel__form__field__label in-form">{fieldLabel}{optional && <span className="text-optional"> ({optionalText})</span>}</label>
                <div className="data-panel__form__field__input" title={disabled && fieldValue ? fieldValue : null}>
                    <div className="data-panel__form__field__input-group">
                        <input
                            value={fieldValue}
                            onChange={event => fieldOnChange(event.target.value)}
                            type="text"
                            id={`id_${fieldName}`}
                            name={fieldName}
                            maxLength={maxLength}
                            placeholder={placeholder}
                            autoComplete="off"
                            className={disabled ? "is-disabled" : ""}
                            disabled={disabled}
                        />
                        <div className="input-group-append">
                            <UniversalButton type="search_or_create" text={<Fragment><Icon containerClassName="icon-inline" icon={faIcon({ name: "qrcode-read", style: "regular" })} className="no-margin" /></Fragment>} handler={() => this.setState({isScannerOpen: true})} onPointerDown={preloadCodeScanner} title="Scan a barcode or QR code" disabled={disabled} immediate={true}></UniversalButton>
                        </div>
                    </div>
                </div>
                {children}
                {errors[fieldName] && <div className="data-panel__form__field__errors" aria-label="Field Errors">{errors[fieldName]}</div>}
                <RegisterCodeDialog
                    isOpen={this.state.isScannerOpen}
                    onOpenChange={isScannerOpen => this.setState({isScannerOpen})}
                    onRegister={fieldOnChange}
                    pricebookItemId={pricebookItemId}
                />
            </div>
        )
    }
}

export default BarcodeField;
